/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type StudentBooked_student = {|
  +jobSessions: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string;
      |};
    |}>;
    +pageInfo: {|
      +hasNextPage: boolean;
    |};
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "bookedCount",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "bookedCursor",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "bookedCount",
        "cursor": "bookedCursor",
        "direction": "forward",
        "path": [
          "jobSessions"
        ]
      }
    ]
  },
  "name": "StudentBooked_student",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "jobSessions",
      "args": [
        {
          "kind": "Literal",
          "name": "status",
          "value": [
            "Started"
          ],
          "type": "[JobSessionStatus]"
        }
      ],
      "concreteType": "JobSessionConnection",
      "name": "__StudentBooked_jobSessions_connection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "JobSessionEdge",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "JobSession",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "id",
                  "storageKey": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "StudentJobSessionBooked_session",
                  "args": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__StudentBooked_jobSessions_connection{\"status\":[\"Started\"]}"
    }
  ],
  "type": "Student"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/modules/admin/student/components/__generated__/StudentBooked_student.graphql.js